import { ContratoModel } from './ContratoModel';

export class ContratoWrapperModel {
    compra_liberada: boolean = false
    url_contratar: string = ""
    contratos: Array<ContratoModel> = []
    compra_cr_liberada: boolean
}